export type CheckoutStatus = 'success' | 'cancel' | 'unknown'
export type Lang = 'da' | 'en'

const KNOWN_STATUSES: readonly CheckoutStatus[] = ['success', 'cancel'] as const
const KNOWN_LANGS: readonly Lang[] = ['da', 'en'] as const

export function parseStatus(search: string): CheckoutStatus {
  const raw = new URLSearchParams(search).get('status')?.toLowerCase()
  return KNOWN_STATUSES.find((s) => s === raw) ?? 'unknown'
}

export function parseLang(search: string, navigatorLanguage?: string | null): Lang {
  const fromQuery = new URLSearchParams(search).get('lang')?.toLowerCase()
  const matched = KNOWN_LANGS.find((l) => l === fromQuery)
  if (matched) return matched

  const fromNavigator = navigatorLanguage?.slice(0, 2).toLowerCase()
  return fromNavigator === 'en' ? 'en' : 'da'
}
